import { useStore } from 'zustand';

import { setUserLocation, userLocationStore } from '@/store/user-location.store';
import { Place } from '@/types/google-maps.types';

interface UseUserLocationReturn {
  userLocation?: Place;
  setUserLocation: (userLocation: Place) => void;
}

export function useUserLocation(): UseUserLocationReturn {
  const userLocation = useStore(userLocationStore, (state) => state?.userLocation);

  return { userLocation, setUserLocation };
}
